import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './ToggleTag.css';

class ToggleTag extends Component {
  static propTypes = {
    tags: PropTypes.object.isRequired,
    white: PropTypes.bool,
    onClick: PropTypes.func
  }

  state = {
    toggleSide: null,
    toggleOffSet: null,
    isHovered: null
  }

  leftToggleRef = createRef();
  rightToggleRef = createRef();

  handleClick = e => {
    e.preventDefault();
    const { onClick } = this.props;
    const { toggleSide } = this.state;
    let { toggle } = e.currentTarget.dataset;

    const toggleOffSet = toggle === 'left'
      ? this.rightToggleRef.current.offsetWidth
      : this.leftToggleRef.current.offsetWidth;

    if (toggleSide === toggle) {
      toggle = null;
    }

    this.setState({
      toggleSide: toggle,
      toggleOffSet
    });

    onClick && onClick(e);
  }

  handleMouseEnter = e => {
    const { toggle } = e.currentTarget.dataset;

    this.setState({ isHovered: toggle });
  }

  handleMouseLeave = () => this.setState({ isHovered: null });

  renderActiveToggle = () => {
    const { toggleSide, toggleOffSet } = this.state;
    const activeStyles = toggleSide === 'left'
      ? { left: '0', right: `${toggleOffSet}px` }
      : { left: `${toggleOffSet}px`, right: '0' };

    return <span className={styles.active} style={activeStyles}></span>;
  }

  renderTag = (name, direction, ref) => {
    const cx = classnames.bind(styles);
    const classes = cx( 'toggle', direction );

    return (
      <li
        className={classes}
        data-toggle={direction}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
        ref={ref}
      >
        {direction === 'right' ? <Icon icon={'link-arrow-right-17'} type={'other'}/> : null}
        {name}
        {direction === 'left' ? <Icon icon={'link-arrow-right-17'} type={'other'}/> : null}
      </li>
    );
  }

  render () {
    const { white, tags } = this.props;
    const { isHovered, toggleSide } = this.state;

    const cx = classnames.bind(styles);
    const classes = cx(
      'wrapper',
      {
        'whiteBg': white,
        'hoverLeft': isHovered === 'left',
        'hoverRight': isHovered === 'right',
        'active': toggleSide
      }
    );

    return (
      <ul className={classnames('tag', classes)}>
        {toggleSide && this.renderActiveToggle()}
        {this.renderTag(tags.left, 'left', this.leftToggleRef)}
        {this.renderTag(tags.center, 'center')}
        {this.renderTag(tags.right, 'right', this.rightToggleRef)}
      </ul>
    );
  }
}

export default ToggleTag;



// WEBPACK FOOTER //
// ./src/uis/elements/Tags/FiltersTag/ToggleTag/ToggleTag.js